import React from "react";
import { Route } from "react-router";
import { AdminCompaniesPage } from "../components/admin/Admin.Companies.Page";
import { AdminExpertsPageContent } from "../components/admin/Admin.Experts.PageContent";
import { AdminInterviewExperienceAIPage } from "../components/admin/Admin.InterviewExperience.AI.Page";
import { AdminLedgerBalancesPageContent } from "../components/admin/Admin.LedgerBalances.PageContent";
import { AdminOrdersPageContent } from "../components/admin/Admin.Orders.PageContent";
import { AdminPaymentReleaseRequestsPageContent } from "../components/admin/Admin.PaymentReleaseRequests.PageContent";
import { AdminQuestionAIPage } from "../components/admin/Admin.Question.AI.Page";
import { AdminRawContentPage } from "../components/admin/Admin.RawContent.Page";
import { AdminSkillsPageContent } from "../components/admin/Admin.Skills.PageContent";
import { AdminUsersPageContent } from "../components/admin/Admin.Users.PageContent";
import { AdminAppLogsPage } from "../components/admin/AdminAppLogsPage";
import { AdminInterviewExperiencesContent } from "../components/admin/AdminInterviewExperiencesContent";
import AdminPage from "../components/admin/AdminPage";
import { AdminPaymentsContent } from "../components/admin/AdminPaymentsContent";
import { AdminQuestionsContent } from "../components/admin/AdminQuestionsContent";
import { AdminSessionsContent } from "../components/admin/AdminSessionsContent";
import { AdminWithdrawalsPageContent } from "../components/admin/AdminWithdrawals.PageContent";
import { adminLinkConstants } from "../constants";
import { SystemParametersPageContent } from "../system/SystemParametersPage";

function AdminOrders() {
  return <AdminPage contentComponent={AdminOrdersPageContent} />;
}

function AdminPRRs() {
  return (
    <AdminPage contentComponent={AdminPaymentReleaseRequestsPageContent} />
  );
}

function AdminUsers() {
  return <AdminPage contentComponent={AdminUsersPageContent} />;
}

function AdminRawContent() {
  return <AdminPage contentComponent={AdminRawContentPage} />;
}

function AdminExperts() {
  return <AdminPage contentComponent={AdminExpertsPageContent} />;
}

function AdminSkills() {
  return <AdminPage contentComponent={AdminSkillsPageContent} />;
}

function AdminCompanies() {
  return <AdminPage contentComponent={AdminCompaniesPage} />;
}

function AdminLedgerBalances() {
  return <AdminPage contentComponent={AdminLedgerBalancesPageContent} />;
}

function AdminPayments() {
  return <AdminPage contentComponent={AdminPaymentsContent} />;
}

function AdminWithdrawals() {
  return <AdminPage contentComponent={AdminWithdrawalsPageContent} />;
}

function AdminSessions() {
  return <AdminPage contentComponent={AdminSessionsContent} />;
}

function AdminInterviewExperiences() {
  return <AdminPage contentComponent={AdminInterviewExperiencesContent} />;
}

function AdminInterviewExperienceAICreate() {
  return <AdminPage contentComponent={AdminInterviewExperienceAIPage} />;
}

function AdminQuestionAICreate() {
  return <AdminPage contentComponent={AdminQuestionAIPage} />;
}

function AdminAppLogs() {
  return <AdminPage contentComponent={AdminAppLogsPage} />;
}

function AdminQuestionsPage() {
  return <AdminPage contentComponent={AdminQuestionsContent} />;
}

function AdminSystemParameters() {
  return <AdminPage contentComponent={SystemParametersPageContent} />;
}

export function AdminRoutes() {
  return (
    <>
      <Route
        exact
        path={adminLinkConstants.PAYMENTS}
        component={AdminPayments}
      />
      <Route
        exact
        path={adminLinkConstants.BOOKINGS}
        component={AdminSessions}
      />
      <Route
        exact
        path={adminLinkConstants.INTERVIEW_EXPERIENCES}
        component={AdminInterviewExperiences}
      />
      <Route
        exact
        path={adminLinkConstants.ADMIN_INTERVIEW_EXPERIENCE_CREATE_AI}
        component={AdminInterviewExperienceAICreate}
      />
      <Route
        exact
        path={adminLinkConstants.QUESTIONS}
        component={AdminQuestionsPage}
      />
      <Route
        exact
        path={adminLinkConstants.RAW_CONTENT}
        component={AdminRawContent}
      />
      <Route
        exact
        path={adminLinkConstants.ADMIN_QUESTION_CREATE_AI}
        component={AdminQuestionAICreate}
      />
      <Route
        exact
        path={adminLinkConstants.ADMIN_AI_LOGS}
        component={AdminAppLogs}
      />
      <Route exact path={adminLinkConstants.ORDERS} component={AdminOrders} />
      <Route exact path={adminLinkConstants.USERS} component={AdminUsers} />
      <Route exact path={adminLinkConstants.EXPERTS} component={AdminExperts} />

      <Route exact path={adminLinkConstants.PRRS} component={AdminPRRs} />
      <Route
        exact
        path={adminLinkConstants.LEDGER_BALANCES}
        component={AdminLedgerBalances}
      />
      <Route
        exact
        path={adminLinkConstants.WITHDRAWALS}
        component={AdminWithdrawals}
      />

      <Route exact path={adminLinkConstants.SKILLS} component={AdminSkills} />
      <Route
        exact
        path={adminLinkConstants.COMPANIES}
        component={AdminCompanies}
      />
      <Route
        exact
        path={adminLinkConstants.SYSTEM_PARAMETERS}
        component={AdminSystemParameters}
      />
    </>
  );
}
